import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  noRewardView: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  result: {
    position: "relative",
    width: "100%",
    maxHeight: 340,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    bottom: 65,
    position: "relative",
  },
  img: {
    position: "absolute",
    animation: "$introEffect 3s linear infinite",
  },
  gem: {
    position: "absolute",
    width: 80,
    height: 80,
  },
  gemLeft: {
    position: "absolute",
    width: 22,
    top: 20,
    animation: "$broke_left 1s ease-in-out infinite",
  },
  gemRight: {
    width: 15,
    position: "absolute",
    top: 25,
    left: 65,
    animation: "$broke_left 1s ease-in-out infinite",
  },
  gemMiddle: {
    width: 23,
    position: "absolute",
    top: 15,
    left: 30,
    animation: "$broke_middle 1s ease-in-out infinite",
  },
  gemTop: {
    width: 25,
    position: "absolute",
    top: 0,
    left: 50,
    animation: "$broke_top 1s ease-in-out infinite",
  },
  "@keyframes introEffect": {
    "0%": {
      transform: "rotate(0)",
    },
    "10%": {
      transform: "rotate(0)",
    },
    "30%": {
      transform: "rotate(50deg)",
    },
    "50%": {
      transform: "rotate(100deg)",
    },
    "80%": {
      transform: "rotate(200deg)",
    },
    "100%": {
      transform: "rotate(300deg)",
    },
  },
  "@keyframes broke_left": {
    "0%": {
      transform: "translateY(0)",
    },
    "50%": {
      transform: "translateY(8px)",
    },
    "100%": {
      transform: "translateY(0)",
    },
  },
  "@keyframes broke_middle": {
    "0%": {
      transform: "translateY(8px)",
    },
    "50%": {
      transform: "translateY(0)",
    },
    "100%": {
      transform: "translateY(8px)",
    },
  },
  "@keyframes broke_top": {
    "0%": {
      transform: "translateX(0)",
    },
    "50%": {
      transform: "translateX(8px)",
    },
    "100%": {
      transform: "translateX(0)",
    },
  },
}));
